// #region Global Imports
import { combineReducers } from "redux";
// #endregion Global Imports

// #region Local Imports
import { CartReducer } from "./cart";
import { UserReducer } from "./User";
// #endregion Local Imports

export default combineReducers({
  CartReducer: CartReducer,
  UserReducer: UserReducer,
});
